@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.product-export-modal {
  width: 400px;
  padding: 20px;
}

.product-import-modal {
  padding: 20px;
}

.import-log-errors {
  margin-top: 5px;
  border: 1px @product-page--modal--error--border-color solid;
  border-radius: 5px;
  background-color: @product-page--modal--error--background-color;
  color: @product-page--modal--error--text-color;
  padding-left: 10px;
  padding-right: 10px;

  .icon {
    fill: @product-page--modal--error--fill-color;
    width: 15px;
    height: 16px;
    min-width: 15px;
    min-height: 16px;
    margin-right: 5px;
  }
}

.import-select-button {
  padding: 0 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    display: none;
  }
}

.import-pill {
  padding: 0 18px;
  color: @product-page--modal-pill--text-color;
}

.import-file-extension-error {
  color: @product-page--modal-status--error--text-color;
  margin-left: 10px;
}
